import {Injectable} from '@angular/core';

@Injectable()
export class CustomerOmnisearchResultsService {
    private results: any = {};

    setResults(data: any) {
        this.results = data;
    }

    getResults(): any {
        return this.results;
    }
}
